import { HrCommonAuthority } from './hr-common-authority';
import { combineAuth } from './hr-authority';

export class AssignmentAuthority extends HrCommonAuthority {

    public static readonly ASSIGNMENT_BASE = "assignment";

    constructor(authority: string) {
        super(combineAuth(AssignmentAuthority.ASSIGNMENT_BASE, authority));
    }


}
